import Echo from "laravel-echo";
import { environment } from "src/environments/environment";
import Pusher from 'pusher-js';

(window as any).Pusher = Pusher;
export function establishWebSocketConnection() {
    const pusherKey = 'kgjvdqi4zf0dfeks5lnv';
    const webSocketHost = environment.webSocketHost;
    // var pusherData: any = {
    //   cluster: 'mt1',
    //   wsHost: webSocketHost,
    //   disableStats: false,
    //   forceTLS: true,
    //   encrypted: true,
    //   scheme: 'https',
    //   enabledTransports: ['ws', 'wss'],
    // };
    // if (webSocketHost === '127.0.0.1') {
    //   pusherData.wsPort = 8081;
    //   pusherData.wssPort = 8081;
    //   pusherData.forceTLS = false;
    //   pusherData.encrypted = false;
    //   pusherData.scheme = 'http';
    // }
    // const pusher = new Pusher(pusherKey, pusherData);
  
    // return new Echo({
    //   broadcaster: 'pusher',
    //   client: pusher,
    //   forceTLS: false,
    // });
    const config: any = {
      broadcaster: 'reverb', 
      key: pusherKey,
      wsHost: webSocketHost,
      wsPort: 8081,
      wssPort: 8081,
      forceTLS: false,
      encrypted : false,
      authEndpoint : 'api/broadcasting/auth',
      enabledTransports: ['ws', 'wss'],
    };
    if (webSocketHost !== '192.168.100.128') {
        console.log({WE_ARE_HERE : webSocketHost});
        config.forceTLS = true;
        config.wssPort = 443; // Si tu es en prod avec SSL
    } else {
        console.log({WE_ARE_HERE_ELSE : webSocketHost});
        config.wsPort = 8081; 
        config.forceTLS = false;
    }

    return new Echo(config);
  }